import { InvoiceField, invoiceFieldCode, invoiceHasValue } from '../invoice-fields'
import React from 'react'
import { Alert, Collapse, Input, Tag } from 'antd'
import { AdditionalField, ReviewValue } from './result-model'
export default function AdditionalFields({
  fields,
  values = {},
  onChange,
  disabled,
  title,
  definitions = [],
  presentation = 'collapse',
  hideEmpty = false,
}: {
  hideEmpty?: boolean
  presentation?: 'collapse' | 'plain'
  definitions?: InvoiceField[]
  fields?: AdditionalField[]
  values?: Record<string, ReviewValue>
  disabled?: boolean
  title: string
  onChange: (values: Record<string, ReviewValue>) => void
}) {
  const visible = (fields || [])
    .map((field, index) => ({ field, index }))
    .filter(({ field, index }) => {
      if (
        hideEmpty &&
        field.certainty !== 'uncertain' &&
        !invoiceHasValue(field.value) &&
        !invoiceHasValue(values[String(index)])
      )
        return false
      const code = invoiceFieldCode(field, definitions)
      return (
        !code || fields!.filter(other => invoiceFieldCode(other, definitions) === code).length > 1
      )
    })
  if (!visible.length) return null
  const content = (
    <>
      {visible.some(({ field }) => field.certainty === 'uncertain') && (
        <Alert
          type="warning"
          showIcon
          message="Есть неуверенно распознанные значения — сверьте их с оригиналом"
        />
      )}
      <div className="supply-check__additional-grid">
        {visible.map(({ field, index }) => (
          <label key={index}>
            <span>
              {field.label}
              {field.page && <small> · стр. {field.page}</small>}
              {field.certainty === 'uncertain' && <Tag color="warning">Проверить</Tag>}
            </span>
            <Input
              size="small"
              disabled={disabled}
              aria-label={field.label}
              value={String(values[String(index)] ?? field.value ?? '')}
              onChange={event => onChange({ ...values, [String(index)]: event.target.value })}
            />
            {field.note && <small>{field.note}</small>}
          </label>
        ))}
      </div>
    </>
  )
  return presentation === 'plain' ? (
    <section className="supply-check__plain-fields">
      <h4>{title}</h4>
      {content}
    </section>
  ) : (
    <Collapse
      className="supply-check__additional"
      size="small"
      items={[{ key: 'fields', label: `${title} · ${visible.length}`, children: content }]}
    />
  )
}
